/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Title_TailInputs */

const en_portal_view_title_tail = /** @type {(inputs: Portal_View_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`as you.`)
};

const pl_portal_view_title_tail = /** @type {(inputs: Portal_View_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`co Ty.`)
};

/**
* | output |
* | --- |
* | "as you." |
*
* @param {Portal_View_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_title_tail = /** @type {((inputs?: Portal_View_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_title_tail(inputs)
	return en_portal_view_title_tail(inputs)
});